export interface SearchEntry {
  title: string;
  desc: string;
  href: string;
  category: string;
  keywords: string;
}

// 结果分组展示顺序
export const searchCategories = ['产品', '解决方案', '客户案例', '九畴云市', '关于华辉'];

// 热门搜索词（空搜索状态展示）
export const popularSearches = [
  '自由流停车',
  '数字红包',
  '九畴云市',
  '智慧农业',
  'TOMA 智能体',
  '数字货架',
  '智慧餐饮',
  '农产品溯源',
];

// 站内搜索索引：覆盖产品、解决方案、客户案例、九畴云市与关于华辉等主要内容入口
export const searchIndex: SearchEntry[] = [
  // 产品
  {
    title: 'LORA车辆探测器',
    desc: '路内停车设备 · 车辆探测终端',
    href: '/products',
    category: '产品',
    keywords: 'LORA 车辆探测器 路内停车 地磁 检测',
  },
  {
    title: 'NB-IOT车辆探测器',
    desc: '路内停车设备 · 窄带物联车辆探测',
    href: '/products',
    category: '产品',
    keywords: 'NB-IOT 车辆探测器 路内停车 物联 泊位',
  },
  {
    title: '网关',
    desc: '路内停车设备 · 无线组网网关',
    href: '/products',
    category: '产品',
    keywords: '网关 组网 LoRa NB-IOT 路内停车',
  },
  {
    title: 'PDA手持终端',
    desc: '路内停车设备 · 手持取证与巡检',
    href: '/products',
    category: '产品',
    keywords: 'PDA 手持终端 巡检 取证 路内停车',
  },
  {
    title: '车载卡',
    desc: '路内停车设备 · 车辆身份识别',
    href: '/products',
    category: '产品',
    keywords: '车载卡 车辆 身份 识别 停车',
  },
  {
    title: 'RFID读卡器',
    desc: '路内停车设备 · 射频读卡识别',
    href: '/products',
    category: '产品',
    keywords: 'RFID 读卡器 射频 识别 路内停车',
  },
  {
    title: 'RFID雷达探测读卡器',
    desc: '路内停车设备 · 雷达复合读卡',
    href: '/products',
    category: '产品',
    keywords: 'RFID 雷达 探测 读卡器 路内停车',
  },
  {
    title: 'AI智能停车视频取证巡检终端',
    desc: '路内停车设备 · 视频取证巡检',
    href: '/products',
    category: '产品',
    keywords: 'AI 停车 视频 取证 巡检 终端',
  },
  {
    title: '高速道闸',
    desc: '停车场设备 · 通道控制道闸',
    href: '/products',
    category: '产品',
    keywords: '道闸 高速 通道 停车场 出入口',
  },
  {
    title: '车牌识别一体机',
    desc: '停车场设备 · 车牌识别',
    href: '/products',
    category: '产品',
    keywords: '车牌识别 一体机 停车场 出入口',
  },
  {
    title: '显示屏幕',
    desc: '停车场设备 · 出入口显示屏幕',
    href: '/products',
    category: '产品',
    keywords: '显示屏幕 停车场 收费 显示',
  },
  {
    title: '补光灯',
    desc: '停车场设备 · 识别补光',
    href: '/products',
    category: '产品',
    keywords: '补光灯 停车场 识别 补光',
  },
  {
    title: '车位锁',
    desc: '停车场设备 · 车位管控',
    href: '/products',
    category: '产品',
    keywords: '车位锁 停车场 车位 管控',
  },
  {
    title: '诱导屏',
    desc: '停车场设备 · 车位诱导引导',
    href: '/products',
    category: '产品',
    keywords: '诱导屏 车位 引导 停车场',
  },
  {
    title: '吊顶式车辆探测器',
    desc: '停车场设备 · 车位占用探测',
    href: '/products',
    category: '产品',
    keywords: '吊顶 车辆探测器 车位 占用 停车场',
  },
  {
    title: '智慧停车产品总览',
    desc: '路内停车设备与停车场设备两大类产品',
    href: '/products',
    category: '产品',
    keywords: '产品 智慧停车 路内停车设备 停车场设备',
  },

  // 解决方案
  {
    title: '自由流停车解决方案',
    desc: '停车场通行、引导、收费与运营数字化',
    href: '/solutions/smart-parking',
    category: '解决方案',
    keywords: '自由流停车 停车场 通行 引导 收费 运营',
  },
  {
    title: '智慧餐饮解决方案',
    desc: '餐厅经营数字化与后厨供应链协同',
    href: '/solutions/smart-catering',
    category: '解决方案',
    keywords: '智慧餐饮 餐厅 后厨 供应链 数字菜单',
  },
  {
    title: '数字红包解决方案',
    desc: '数字人民币红包与消费促进',
    href: '/solutions/red-packet',
    category: '解决方案',
    keywords: '数字红包 数字人民币 消费 权益 促进',
  },
  {
    title: '智慧农业解决方案',
    desc: '精准种植与农产品全程追溯',
    href: '/solutions/smart-agriculture',
    category: '解决方案',
    keywords: '智慧农场 农业 农产品 溯源 数字货架 物联网',
  },
  {
    title: '整体解决方案总览',
    desc: '县域数字商业与乡村数字经济整体方案',
    href: '/solutions',
    category: '解决方案',
    keywords: '解决方案 县域 数字商业 乡村 数字经济',
  },
  {
    title: '行业咨询',
    desc: '面向行业的数字化转型咨询与方案设计',
    href: '/industry-consulting',
    category: '解决方案',
    keywords: '行业 咨询 数字化转型 方案',
  },

  // 客户案例
  {
    title: '九畴云市项目',
    desc: '核心战略项目，数商共同体与闽湖数字城',
    href: '/jiuchou',
    category: '客户案例',
    keywords: '九畴云市 战略 数商共同体 闽湖数字城 案例',
  },
  {
    title: '帝星咖啡',
    desc: '0# 数商综合体验证场',
    href: '/cases',
    category: '客户案例',
    keywords: '帝星咖啡 数商 体验 验证 案例',
  },
  {
    title: '中仙数智商贸',
    desc: '智慧农场解决方案落地案例',
    href: '/solutions/smart-farm',
    category: '客户案例',
    keywords: '中仙 数智商贸 农贸市场 智慧农场 溯源 案例',
  },
  {
    title: '铼停科技自由流停车',
    desc: '自由流停车解决方案合作案例',
    href: '/solutions/smart-parking',
    category: '客户案例',
    keywords: '铼停科技 自由流停车 合作 案例',
  },
  {
    title: '敬龙国际「味聚」项目',
    desc: '连接消费者、餐饮商家与供应链的数字化餐饮服务平台',
    href: '/weiju',
    category: '客户案例',
    keywords: '味聚 敬龙国际 聚餐 餐饮 供应链 甄选商城 数字权益 案例',
  },
  {
    title: '客户案例总览',
    desc: '重点项目与客户案例集中展示',
    href: '/cases',
    category: '客户案例',
    keywords: '客户案例 重点案例 成果 案例',
  },

  // 九畴云市
  {
    title: '五层平台架构',
    desc: '从用户层到治理层的五层平台架构',
    href: '/jiuchou/architecture',
    category: '九畴云市',
    keywords: '九畴云市 架构 五层 平台 治理层 用户层',
  },
  {
    title: '一条业务主链',
    desc: '一笔交易一条数据链',
    href: '/jiuchou/chain',
    category: '九畴云市',
    keywords: '九畴云市 业务主链 数据链 交易',
  },
  {
    title: '云节点',
    desc: '云节点与云社员的县域网络布局',
    href: '/jiuchou/yun-node',
    category: '九畴云市',
    keywords: '九畴云市 云节点 云社员 县域 网络',
  },
  {
    title: '供应链与服务',
    desc: '供应链与服务经济协同体系',
    href: '/jiuchou/supply-service',
    category: '九畴云市',
    keywords: '九畴云市 供应链 服务 协同',
  },
  {
    title: '数字消费',
    desc: '数字消费场景与权益体系',
    href: '/jiuchou/consumption',
    category: '九畴云市',
    keywords: '九畴云市 数字消费 权益 场景',
  },
  {
    title: '清分结算',
    desc: '多方协同的智能清分与自动结算',
    href: '/jiuchou/settlement',
    category: '九畴云市',
    keywords: '九畴云市 清分 结算 智能清分 多方协同',
  },
  {
    title: '数据与 AI',
    desc: 'TOMA 智能体与数据飞轮',
    href: '/jiuchou/data-ai',
    category: '九畴云市',
    keywords: '九畴云市 数据 AI TOMA 智能体 数据飞轮',
  },
  {
    title: '体验九畴云市',
    desc: '五角色模拟运营环境',
    href: '/experience',
    category: '九畴云市',
    keywords: '九畴云市 体验 模拟 运营 五角色',
  },
  {
    title: '0# 首发',
    desc: '城市端商业闭环的示范验证场景',
    href: '/launch',
    category: '九畴云市',
    keywords: '九畴云市 0# 首发 示范 验证 城市',
  },
  {
    title: '千县万村',
    desc: '区域复制与规模化解决方案',
    href: '/scale',
    category: '九畴云市',
    keywords: '九畴云市 千县万村 区域 复制 规模化',
  },

  // 关于华辉
  {
    title: '公司',
    desc: '华辉数智是谁与业务角色',
    href: '/about/company',
    category: '关于华辉',
    keywords: '公司 华辉数智 业务 角色 关于',
  },
  {
    title: '投资关系',
    desc: '投资、合作与治理信息',
    href: '/about/investor-relations',
    category: '关于华辉',
    keywords: '投资 关系 合作 治理 资本',
  },
  {
    title: '相关资料',
    desc: '企业资料与可下载内容',
    href: '/about/resources',
    category: '关于华辉',
    keywords: '资料 下载 资质 企业 文件',
  },
  {
    title: '战略与政策',
    desc: '战略规划与政策对接方向',
    href: '/strategy',
    category: '关于华辉',
    keywords: '战略 政策 规划 414 政策对接',
  },
  {
    title: '技术与能力',
    desc: '核心技术能力与技术积累',
    href: '/tech',
    category: '关于华辉',
    keywords: '技术 能力 核心 研发',
  },
  {
    title: '业务联系',
    desc: '投资 · 产业 · 县域 · 政策 · 技术合作',
    href: '/contact/business',
    category: '关于华辉',
    keywords: '业务联系 合作 投资 产业 县域 政策 联系',
  },
  {
    title: '项目演示',
    desc: '九畴云市项目在线演示',
    href: '/demo',
    category: '关于华辉',
    keywords: '项目演示 演示 demo 体验',
  },
];